import React from 'react'
import useSurveyLocale from '@aytm/app/swidget/base/modules/locale/useSurveyLocale'
import style from './AddToCartButton.module.scss'

interface IAddToCartButtonProps {
  index: number
  findability: boolean
  amount: number
  limit: number
  onAddToCart: (index: number, qnt?: number) => void
  onSetQuantity: (index: number, qnt: number) => void
}

const AddToCartButton = ({ index, findability, amount, limit, onAddToCart, onSetQuantity }: IAddToCartButtonProps) => {
  const { t } = useSurveyLocale()
  const atCap = !findability && limit > 0 && amount >= limit
  const onClick = (event: React.MouseEvent) => {
    event.stopPropagation()
    // findability: the product is a single pick — set its quantity to exactly 1.
    // shopping: each click adds one more.
    if (findability) onSetQuantity(index, 1)
    else onAddToCart(index, 1)
  }

  return (
    <button
      type="button"
      className={style.addToCart}
      data-testid="SW-EC-AddToCartButton"
      onClick={onClick}
      disabled={atCap}
    >
      {t('questions', 'ec', 'chewy', 'addToCart')}
    </button>
  )
}

export default AddToCartButton
